import React from 'react';
import { SideModal } from '@cokitchen/cokitchen-components';
import { MenuHorizontalIcon, NotificationIcon } from 'cokitchen-icons';
import Profile from './profile';
import useDashboardContext from 'contexts/dashboard.context';
import Sidebar from 'components/sidebar';
import SearchInput from 'components/base/search-input';
import foodcourtLogo from 'assets/images/logo.png';
import CokitchenDropdown from './cokitchen-dropdown';

const Header = () => {
  const { showMobileSidebar, setShowMobileSidebar, searchValue, setSearchValue } =
    useDashboardContext();

  return (
    <div className='sticky z-10 bg-white top-0 h-20 px-3 lg:px-10 py-4 border-b border-gray-13 flex flex-wrap gap-4 items-center text-sm font-medium'>
      <div className='grow flex items-center h-full'>
        <div className='inline-flex gap-2 items-center lg:hidden'>
          <span
            role='menubar'
            onClick={() => setShowMobileSidebar(true)}
            className='p-2 bg-black rounded-full text-white'>
            <MenuHorizontalIcon />
          </span>
          <img src={foodcourtLogo} alt='' className='' />
        </div>

        <div className='max-lg:hidden'>
          <SearchInput value={searchValue} handleChange={(e) => setSearchValue(e.target.value)} />
        </div>
      </div>

      <div className='flex items-center gap-4 flex-wrap'>
        <div className='max-lg:hidden flex items-center gap-5'>
          <CokitchenDropdown />
          <div className='bg-[#e2e3e4] h-6 w-[1px]' />
          <div className='relative'>
            <NotificationIcon className='w-12 h-12 p-[10px] rounded-full border border-gray-15 text-gray-8' />

            <div className='w-3 h-3 absolute right-[11.5px] top-[8px] bg-red-5 rounded-full border-2 border-white' />
          </div>
        </div>

        <Profile />
      </div>
      <SideModal
        title={<CokitchenDropdown />}
        isOpen={showMobileSidebar}
        onRequestClose={() => setShowMobileSidebar(false)}
        hideFooter>
        <SearchInput value={searchValue} handleChange={(e) => setSearchValue(e.target.value)} />
        <Sidebar />
      </SideModal>
    </div>
  );
};

export default Header;
